import { useQuery } from '@tanstack/react-query';
import { nextSessions } from '@uplift/api';
import { BaseQueryOpts } from '@uplift/queries';

export const useCanScheduleWithProvider = (providerId: string, opts?: BaseQueryOpts) => {
  const { data: nextSessionsData, isLoading } = useQuery({
    queryKey: [ 'next-sessions-for-provider', providerId ],
    queryFn: () => nextSessions({
      limit: 1,
      provider_id: providerId
    }).then(res => res.data),
    enabled: !!providerId,
    ...opts,
  });

  if (!nextSessionsData) {
    return { canSchedule: false, isLoading };
  }

  return { canSchedule: !nextSessionsData.length, isLoading };
};
